import { render, staticRenderFns } from "./select-role-list.vue?vue&type=template&id=44a1f27d&scoped=true"
import script from "./select-role-list.vue?vue&type=script&lang=js"
export * from "./select-role-list.vue?vue&type=script&lang=js"
import style0 from "./select-role-list.vue?vue&type=style&index=0&id=44a1f27d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a1f27d",
  null
  
)

export default component.exports